import { SkeletonLoader } from '@toggle/design-system';
import { formatDateToLocale, Formats } from '@toggle/helpers';
import clsx from 'clsx';
import { format } from 'date-fns';
import React from 'react';

import { useLanguageStore } from '~/stores/use-language-store/useLanguageStore';

import styles from './CardDay.module.scss';

export interface CardDayProps {
  date: Date;
  isActive?: boolean;
  rows: {
    label: string;
    count: number;
    isLoading: boolean;
    bgColor?: string;
  }[];
  handleCardClick: () => void;
}

export const CardDay = ({
  isActive = false,
  date,
  rows,
  handleCardClick,
}: CardDayProps) => {
  const timestamp = date.valueOf();
  const languageSetting = useLanguageStore(state => state.languageSetting);

  return (
    <div
      className={clsx(styles.cardContainer, {
        [styles.cardContainerActive]: isActive,
      })}
      data-testid={`card-day-${format(date, 'EEEE')}`}
      onClick={handleCardClick}
    >
      <p className={styles.cardDateWrapper}>
        <span className={styles.dayOfWeek}>
          {formatDateToLocale(languageSetting, date, Formats['EEEE d'])}
        </span>
      </p>
      <div className={styles.rowWrapper}>
        {rows.map((r, index) => {
          if (r.isLoading) {
            return (
              <SkeletonLoader
                key={`${timestamp}-${index}`}
                areas={[
                  {
                    styles: {
                      width: '100%',
                      height: '20px',
                      borderRadius: '4px',
                    },
                  },
                ]}
              />
            );
          }

          const isEmptyRow = !r.count;
          return (
            <div
              key={`${timestamp}-${index}`}
              className={styles.row}
              style={
                !isEmptyRow && r.bgColor
                  ? { backgroundColor: r.bgColor }
                  : undefined
              }
              data-testid={`${timestamp}-${r.label}`}
            >
              {!isEmptyRow && (
                <>
                  <span>{r.label}</span>
                  <span>{r.count}</span>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
